export interface UserRole {
	id: string
	created_at?: string
	updated_at?: string
	deleted_at?: string
	name: string
}
